import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { DataService } from '../../services/data/data.service';
import { CalendarService } from '../../services/calendar/calendar.service';

@Component({
	selector: 'pcm-invoice-calendar-entries',
	templateUrl: './invoice-calendar-entries.component.html',
	styleUrls: ['./invoice-calendar-entries.component.scss']
})
export class InvoiceCalendarEntriesComponent implements OnInit {
	// an array of object {billingstart: date, billingend: date} for billing periods
	// or an array of date for invoice run dates
	// date is in format of  'yyyy-mm-dd'
	@Input() dates = [];

	// 'invoicedates' or 'events'
	@Input() type: 'invoicedates' | 'events';

	// emit if any date is empty
	@Output() allDatesEntered: EventEmitter<any> = new EventEmitter();

	// an array of object {billingstart: date, billingend: date}
	// or an array of date for invoice run dates
	// date is in datepicker format of {year: number, month: number, day: number}
	dateModel = [];

	numShowDates = 5;
	clickedShowAllDates = false;
	columns = [];
	columnsBilling = [
		{ columnName: 'Billing Start Date', propName: 'billingstart' },
		{ columnName: 'Billing End Date', propName: 'billingend'}
	];
	columnsInvoice = [
		{ columnName: 'Invoice Run Date', propName: 'invoicedate' }
	];

	constructor(
		private dataService: DataService,
		public calendarService: CalendarService,
	) { }

	ngOnInit() {
		// converts dates into dateModel which is in datepicker format
		if (this.dates) {
			if (this.type === 'invoicedates') {
				this.columns = this.columnsInvoice;
				this.dates.forEach(date => {
					this.dateModel.push({
						invoicedate: this.dataService.getDatepickerModel(date.invoicedate)
					});
				});
			} else if (this.type === 'events') {
				this.columns = this.columnsBilling;
				this.dates.forEach(date => {
					this.dateModel.push({
						billingstart: this.dataService.getDatepickerModel(date.billingstart),
						billingend: this.dataService.getDatepickerModel(date.billingend)
					});
				});
			}
		}
		this.allDatesEntered.emit({
			data: this.calendarService.isAllDatesEntered(this.dates, this.type)
		});
	}

	// when dateModel is modified using datepicker
	updateDate(inx, prop) {
		this.dates[inx][prop] = this.dataService.formatPickerDate(this.dateModel[inx][prop]);
		if (this.type !== 'invoicedates') {
			// need update the date of billingstart of the next entry if available
			this.updateStartDate(inx, prop);
		}
		// check any date in the invoice calendar entry is empty and emit the result
		this.allDatesEntered.emit({
			data: this.calendarService.isAllDatesEntered(this.dates, this.type)
		});
	}

	updateStartDate(inx, prop) {
		if (prop === 'billingend' && this.dates[inx + 1]) {
			this.dates[inx + 1]['billingstart'] = this.getStartDate(this.dates[inx][prop]);
			this.dateModel[inx + 1]['billingstart'] = this.dataService.getDatepickerModel(this.dates[inx + 1]['billingstart']);
		}
	}

	// start date needs be set as the next day of end date in the previous row
	getStartDate(dateString) {
		const nextDay = this.dataService.getNextDay(dateString);
		return this.dataService.formatDate(nextDay);
	}

	addDate() {
		if (this.dates.length === 0) {	// add date for a new calendar
			this.dateModel = [];
		}
		if (this.type === 'invoicedates') {
			this.addInvoiceDate();
		} else {
			let startDate = '';
			let startDateModel = {};
			if (this.dates.length >= 1 && this.dates[this.dates.length - 1].billingend) {
				startDate = this.getStartDate(this.dates[this.dates.length - 1].billingend);
			}
			if (this.dateModel.length >= 1 && this.dateModel[this.dateModel.length - 1]['billingend']) {
				startDateModel = this.dataService.getDatepickerModel(startDate);
			} else {
				startDateModel = {year: '', month: '', day: ''};
			}
			this.dates.push({
				billingstart: startDate,
				billingend: ''
			});
			this.dateModel.push({
				billingstart: startDateModel,
				billingend: {year: '', month: '', day: ''}
			});
		}
		this.allDatesEntered.emit({
			data: false
		});
	}

	addInvoiceDate() {
		this.dates.push({
			invoicedate: ''
		});
		this.dateModel.push({
			invoicedate: {year: '', month: '', day: ''}
		});
	}

	removeDate(event, i) {
		this.dates.splice(i, 1);
		this.dateModel.splice(i, 1);

		this.allDatesEntered.emit({
			data: this.calendarService.isAllDatesEntered(this.dates, this.type)
		});
	}

	dateNotSaturday = (dateModel, current) => {
		const date = new Date(current.year, current.month - 1, dateModel.day);
		const day = date.getDay();
		return day !== 6;
	}

	dateNotFriday = (dateModel, current) => {
		const date = new Date(current.year, current.month - 1, dateModel.day);
		const day = date.getDay();
		return day !== 5;
	}

	getMarkDisabledFunction(propName) {
		if (propName === 'billingstart') {
			return this.dateNotSaturday;
		} else if (propName === 'billingend') {
			return this.dateNotFriday;
		}
	}

	getCalendarMinDate(index, propName) {
		if (propName === 'billingend') {
			return this.dateModel[index].billingstart;
		}
	}

	getIsFieldReadOnly(itemIsReadOnly, propName, index) {
		if (propName === 'billingstart') {
			return (itemIsReadOnly || index > 0);
		} else {
			return itemIsReadOnly;
		}
	}

	showAllDates() {
		this.clickedShowAllDates = true;
	}

	getCalendarMessage() {
		if (this.type === 'invoicedates') {
			return this.calendarService.removeBillingDatesMessage;
		} else if (this.type === 'events') {
			return this.calendarService.removeInvoiceDatesMessage;
		}
	}
}
